module.exports = __webpack_public_path__ + "static/home/img/1.3e8e5f61.png";